// Сургалт — хэрэглэгчид харагдах цувралууд ангиллаар нь
import React, { useEffect, useMemo, useState } from "react";
import { Spin, message } from "antd";
import { instance } from "utils/axios";
import { SeriesCard, ContinueCard } from "./common";

function Learning() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    instance({ method: "get", url: "/learning/series" })
      .then((res) => setData(res.data || { series: [] }))
      .catch(() => message.error("Мэдээлэл татаж чадсангүй"))
      .then(() => setLoading(false));
  }, []);

  // Ангиллаар бүлэглэнэ (серверийн дарааллыг хадгална)
  const groups = useMemo(() => {
    const m = new Map();
    (data?.series || []).forEach((s) => {
      const k = s.category || "Бусад";
      if (!m.has(k)) m.set(k, []);
      m.get(k).push(s);
    });
    return [...m.entries()];
  }, [data]);

  return (
    <div className="pt-4 md:pt-6 pb-6 max-w-3xl mx-auto flex flex-col gap-4">
      <div>
        <h1 className="ptitle">Сургалт</h1>
        <p className="psub">Эцэг эхэд зориулсан бичлэг, гарын авлага</p>
      </div>

      {loading ? (
        <div className="flex justify-center py-10"><Spin /></div>
      ) : (
        <>
          {data?.continue && <ContinueCard c={data.continue} />}
          {groups.length ? groups.map(([cat, list]) => (
            <section key={cat} className="flex flex-col gap-2.5">
              <h2 className="text-base font-bold text-gray-900 mt-1">{cat}</h2>
              <div className="grid gap-2.5 md:grid-cols-2">
                {list.map((s) => <SeriesCard key={s.id} s={s} />)}
              </div>
            </section>
          )) : (
            <section className="pcard pcard-pad text-center py-10 text-gray-400 text-sm">Одоогоор сургалт алга</section>
          )}
        </>
      )}
    </div>
  );
}

export default Learning;
